/** 與 public/homepage.html 的 #assistant-chat-container 一致 */
export const ASSISTANT_CHAT_CONTAINER_ID = 'assistant-chat-container'

export const DEFAULT_ASSISTANT_ID = 'assistant-dfbb1a90'

export const EMBED_SCRIPT_ID = 'assistant-chat-script'

/** 父頁 postMessage 預設：iframe 內 AI 文字使用一般字級 */
export const DEFAULT_IS_AI_TEXT_NORMAL = true

/** iframe／API 預設指向聊天入口；可用 REACT_APP_CHAT_EMBED_ORIGIN 覆寫 */
export const DEFAULT_CHAT_EMBED_ORIGIN = 'https://portal2.musesai.com:8443'

export function getChatEmbedOriginRaw() {
  return (
    (process.env.REACT_APP_CHAT_EMBED_ORIGIN || '').trim() ||
    DEFAULT_CHAT_EMBED_ORIGIN
  )
}

/** postMessage 的 targetOrigin / event.origin 驗證用 */
export function getChatEmbedOrigin() {
  try {
    return new URL(getChatEmbedOriginRaw()).origin
  } catch {
    return DEFAULT_CHAT_EMBED_ORIGIN
  }
}

/** 供 public/embed.js 的 buildOrigin */
export function getChatEmbedHostOptions() {
  try {
    const u = new URL(getChatEmbedOriginRaw())
    const port = u.port || ''
    return {
      protocol: u.protocol,
      host: u.hostname,
      appPort: port,
      apiPort: port,
    }
  } catch {
    return {
      protocol: 'https:',
      host: 'portal2.musesai.com',
      appPort: '8443',
      apiPort: '8443',
    }
  }
}

/** 正式環境由 chat 服務下發；與 iframe host 同源 */
export function getEmbedScriptUrl() {
  return `${getChatEmbedOrigin()}/embed.js`
}
